import { createCriteriaParameters, standardDeleteQuery, standardGetQuery, standardPutQuery } from "./apiUtils.js";

import { replacePlaceholdersWithObjValues, setDeleteArrayState, setInsertArrayState } from "../shared/miscUtils.js";

import { SNACKBAR_SUCCESS_DELETED, SNACKBAR_SUCCESS_UPDATED } from "../../config/language/english.js";
import * as Constants from "../../config/constants/Constants.js";

/**
 * Function for querying playlists with filters, pagination, sorting etc.
 */
export const queryPlaylists = (props, options = {}) => {
    const path = Constants.API_PLAYLISTS + createCriteriaParameters(options);

    standardGetQuery(props, path, (response) => {
        const states = props.backend.playlists;

        setInsertArrayState(states.setData, response.body.elements);
        states.setQueryLoading(false);

        if (options.pagination === false) return;

        if (options.page !== undefined) states.setQueriedUntil(options.page);
        if (response?.body?.total !== undefined) states.setRowCount(response.body.total);
    });
};

/**
 * Function for querying a single playlist.
 */
export const queryPlaylist = (props, options = {}) => {
    const path = replacePlaceholdersWithObjValues(Constants.API_PLAYLISTS_ID, { playlist_id: options.id });

    standardGetQuery(props, path, (response) => {
        const states = props.backend.playlists;

        setInsertArrayState(states.setData, [{ ...response.body }]);
    });
};

/**
 * Function for updating a playlist.
 */
export const updatePlaylist = (props, options = {}) => {
    const path = replacePlaceholdersWithObjValues(Constants.API_PLAYLISTS_ID, { playlist_id: options.id });

    standardPutQuery(props, path, options.body, (response) => {
        const states = props.backend.playlists;

        setInsertArrayState(states.setData, [{ ...response.body }]);

        states.setSelected([]);

        props.showSnackbar({ message: SNACKBAR_SUCCESS_UPDATED });
    });
};

/**
 * Function for deleting playlists.
 */
export const deletePlaylists = (props, options = {}) => {
    const path = Constants.API_PLAYLISTS;

    standardDeleteQuery(props, path, options.body, (response) => {
        const states = props.backend.playlists;

        setDeleteArrayState(states.setData, options.ids);

        states.setRowCount(states.rowCount - options.ids.length);
        states.setSelected([]);

        props.showSnackbar({ message: SNACKBAR_SUCCESS_DELETED });
    });
};
